"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _log = require("@/utils/log");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _publicFile = require("@/api/publicFile");
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyImageInput',
  props: {
    value: String
  },
  data() {
    return {
      validImageExtension: _lifehikesInitData.validImageExtension,
      thumbnailFile: null,
      showThumbnailUploadErrMsg: false
    };
  },
  methods: {
    chooseThumbnailFile(e) {
      if (e.target.files.length > 0) {
        (0, _log.showDebugLog)('Debug-uploadImg', e.target.files[0]);
        if (e.target.files[0].size <= 1048576) {
          this.thumbnailFile = e.target.files[0];
        } else {
          (0, _log.displayPopupMessage)(this.$i18n.t('otrTraining.imageLimit'), 'error');
          this.$refs.thumbfile.value = '';
        }
      }
    },
    doThumbnailUpload() {
      (0, _log.showDebugLog)('Debug-uploadImgFile', this.thumbnailFile);
      this.$emit('upload-start');
      const thumbnailIconForm = new FormData();
      thumbnailIconForm.append('file', this.thumbnailFile);
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _publicFile.uploadFile)(token, thumbnailIconForm).then(response => {
        this.$emit('upload-end');
        this.showThumbnailUploadErrMsg = false;
        this.$emit('input', response.data.location);
        this.$emit('input', response.data.location);
      }).catch(error => {
        (0, _log.showDebugLog)('upload-img-api-error', error);
        this.$emit('upload-end');
        this.showThumbnailUploadErrMsg = true;
      });
    }
  }
};